import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";

export default function getTranslationFromTransportType(transportType: TransportTypesType): string {
    const availableTransportationTranslations: Record<TransportTypesType, string> = {
        privateTransfer: "private transfer",
        bus: "bus",
        ferry: "ferry",
        train: "train",
        plane: "plane",
    }
    return availableTransportationTranslations[transportType]
}